import React, { useRef, useEffect, useCallback, useState} from 'react';
import PulseLoader from 'react-spinners/PulseLoader'
import ethereum from 'decentralized/ethereum.js';
import {connect} from 'react-redux';

const TagsInfo = ({
    content,
    pendingTransactions,
    setTagSelected,
    onTag,
    tagSelected}) => { 

        let ref = useRef(undefined);
        let [value, setValue] = useState('');
        let [tags, setTags] = useState(content.tags);

        const onChange = useCallback((e) => {
            setValue(e.target.value);
        }, [setValue]);

        useEffect(() => {
            setTags(content.tags);
        }, [setTags, content.ipfsHash, pendingTransactions]);

        useEffect(() => {
            if (!setTagSelected) {
                ref.current.focus();
            }
        }, []);

        const submit = useCallback(() => {
            if (value.trim() === '') {
                // dont enter bullshit tags
                return;
            }
            content.newTag(value);
            setTags([... tags, value]);
            setValue('');
            if (onTag) {
                onTag(value);
            }
        }, [content.ipfsHash, value, tags, setTags, setValue, onTag ]);

        const onKeyDown = useCallback((e) => {
            if (e.key === 'Enter') {
                submit();
            } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                ref.current.blur();
            }
        }, [submit, onTag]);
        
        return (
            <div className="tags-info">
              <div className="tags-container">
                {tags.map(
                    x => <div
              onClick={() => setTagSelected ? setTagSelected(x === tagSelected ? undefined : x) : ''}
              className={x === tagSelected ? "sample-tag selected" :
                         tagSelected ? "sample-tag disabled" : "sample-tag"}>
      {x}
    </div>)}
                <PulseLoader
                  sizeUnit={"px"}
                  size={10}
                  color={'#42f4f1'}
                  loading={pendingTransactions > 0}
                />
              </div>
              <div className="tagger-container">
                <input
                  ref={ref}
                  onKeyDown={onKeyDown}
                  placeholder="Type new tag"
                  onChange={onChange}
                  value={value} type="text" className="sample-tagger"></input>
                <div
                  onClick={submit}
                  className="tag-button">
                  Tag
                </div>
              </div>
            </div>);
    }

const mapStateToProps = (state, props) => {
    return {
        pendingTransactions: state.transactions.pendingTransactions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagsInfo);
